export const environment = {
  name: "dev",
  production: "production",
  apiUrl: 'https://devserver.labbytes.vibytes.com',
  UserPoolId: 'us-east-1_RbGwEQoIE',
  ClientId: '12o9ibo779oim9bbqht29v8nv7'
};



